module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_trouble03-05c9e64b9d4087d15a990226cc08ee0b.png";